<template>
    <router-link :to="{ name: 'monitors.show', params: { id: monitor.id }}">
        <div class="monitor-item">
            <div class="content">
                <figure class="avatar avatar-xl" style="background: none">
                  <img 
                    v-if="monitor.last_check_id != '00000000-0000-0000-0000-000000000000' && monitor.in_progress != true" 
                    class="" 
                    v-lazy="imageHost + '/' + monitor.last_check_id + '-thumbnail.png'">
                  <img v-else class="" src="https://s3.amazonaws.com/pagespy/loading.svg" />

                  <i v-if="monitor.state == 'running'" class="avatar-presence online"></i>
                  <i v-else-if="monitor.state == 'paused'" class="avatar-presence busy"></i>
                  <i v-else class="avatar-presence away"></i>
                </figure>

                <ul class="monitor-properties">
                    <p v-if="monitor.name" class="name">{{ monitor.name }}</p>
                    <p v-else class="name untitled">Untitled</p>

                    <p class="url">
                        <img class="favicon" v-lazy="'https://icons.duckduckgo.com/ip3/'+ parsedURL.hostname +'.ico'" />
                        <span class="hostname">{{ parsedURL.hostname }}</span>
                        <span class="path">{{ parsedURL.path }}</span>
                    </p>

                    <span v-if="monitor.in_progress == false">
                        <li v-if="monitor.last_check"><i class="fa fa-angle-double-right"></i> {{ monitor.last_check | moment('from', currentTime) }}</li>
                        <li v-if="monitor.next_check && monitor.state == 'running'"><i class="fa fa-angle-right"></i> {{ monitor.next_check | moment('from', currentTime) }}</li>
                        <li class="notificators"><i class="fa fa-bell"></i> {{ notificatorsCount }}</li>
                    </span>
                    <span v-else class="checking-message">checking ...</span>
                </ul>
            </div>
        </div>
    </router-link>
</template>

<script>
import uri from 'url'
import { mapGetters } from 'vuex'

export default {
    props: ["monitor"],
    name: 'monitor-item',
    data() {
        return {
            now: this.currentTime
        }
    },
    // ready() {
    //   var self = this;
    //   setInterval(function () {
    //       console.log('updated timestamp')
    //         self.now = Date.now()
    //   }, 1000)
    // }, 
    methods: {
        editMonitor(id) {
            this.$router.push({ path: `/monitors/${id}` })
        },
        pauseMonitor(id) {
            alert(true);
        }
    },
    computed: {
        ...mapGetters({
            currentTime: 'currentTime'
        }),
        parsedURL() {
            return uri.parse(this.monitor.url)
        },
        notificatorsCount() {
          return this.monitor.selected_notificators ? this.monitor.selected_notificators.length : 0;
        }
    }
}
</script>

<style lang="scss">
.monitors-sidebar > a:focus {
      box-shadow: none;
      border: none;
}

.monitors-sidebar > a:last-child {
  flex-grow: 1;
}

.monitor-item {
    border: 1px solid #ffffff;
    margin: 10px 0px;
    background: #fff;
    color: #545454;
    border-radius: 5px;
    position: relative;
    padding: 8px 10px;
    position: relative;
    transition: all 0.4s;

    &:hover {
        cursor: pointer;
        border: 1px solid #dcf2ff;
    }

    &:focus {
      box-shadow: none;
      border: none;
    }

    &:active {
        position: relative;
        top: 4px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        opacity: 0.5;
        transition: all 0.1s;
    }

    .monitor-properties {
        list-style: none;
        margin: 0; padding: 0;

        li {
            display: inline-block;
            padding: 0;
            margin: 0;
            font-size: 11px;
        }

        span.hostname {}
        span.path {
            color: #aaa;
            overflow: hidden;
        }
    }

    p.name {
        padding: 0;
        margin: 0;
        font-weight: bold;
        font-size: 16px;

        &.untitled {
            color: #aaa;
        }
    }

    p.url {
        width: 100%;
        margin: 0;
        padding: 0px;
        font-size: 16px;
        font-weight: 300;
        border-radius: 2px 2px 0px 0px;
        color: #000;

        text-overflow: ellipsis;
        white-space: nowrap;
        color: #9497ad;

        i {
            color: #c1d42d;
        }

        .favicon {
            width: 12px;
            height: 12px;
            opacity: 0.6;
        }
    }

    .content {
        position: relative;
        overflow: hidden;
        color: #9497ad;

        .avatar {
            img {
                border-radius: 10px;
                border: 1px solid #fff;
                opacity: 0.8;
            }
        }

        img.website-screenshot {
            float: left;
            width: 64px;
            border: 1px solid #37b4ff;
            border-radius: 3px;
            box-shadow: 0px 0px 10px rgba(0, 169, 255, 0.4);
            opacity: 0.9;
        }

        ul {
            float: right;
            width: 80%;
        }
    }

    .notificators {
        position: absolute;
        right: 0;
        top: 0;
        color: #b7c4cc;
    }

    .checking-message {
        color: #54d622;
        font-weight: bold;
    }
}

.monitors-sidebar {
    a:link {
        text-decoration: none;
    }
}

// router-link-exact-active router-link-active
.router-link-exact-active {
    .monitor-item {
        background: rgb(255, 255, 255);
        border-color: #fff;
        box-shadow: 0px 2px 15px rgba(208, 208, 208, 0.4), 1px 2px 3px rgb(251, 251, 251);
        transition: all 0.2s;
        position: relative;
        left: 10px;

        .notificators {
            color: #000;
        }


        .content {
            color: #000;

            .url {
                color: #000;

                .favicon {
                    opacity: 1;
                }
            }
        }

        .avatar img {
            border: 1px solid #fff;
            opacity: 1;
        }

        // &:after, &:before {
        //     left: 100%;
        //     top: 50%;
        //     border: solid transparent;
        //     content: " ";
        //     height: 0;
        //     width: 0;
        //     position: absolute;
        //     pointer-events: none;
        // }

        // &:after {
        //     border-color: rgba(151, 204, 237, 0);
        //     border-left-color: rgba(242, 249, 253, 0.71);
        //     border-width: 10px;
        //     margin-top: -10px;
        // }

        // &:before {
        //     border-color: rgba(194, 225, 245, 0);
        //     border-left-color: #cfe6ff;
        //     border-width: 11px;
        //     margin-top: -11px;
        // }
    }
}

</style>




// WEBPACK FOOTER //
// src/components/MonitorItem.vue